import { getSocket } from '@src/App';

export default async (
  name: string,
  isPublic: boolean,
  password: string | null,
  isWagered: boolean,
  wager: number | null,
) => {
  try {
    getSocket().emit('createGame', {
      name,
      isPublic,
      password,
      gameType: isWagered ? 'wager' : 'regular',
      wager,
    });
  } catch (e) {
    console.error(e);
  }
};
